import React from 'react';
import { BsClockHistory } from 'react-icons/bs';
import styles from './styles.module.css';

interface ChangelogEntry {
  date: string;
  version?: string;
  changes: {
    type: 'feature' | 'improvement' | 'fix' | 'integration';
    description: string;
    diff?: {
      before: string;
      after: string;
    };
  }[];
}

const changelogData: ChangelogEntry[] = [
  {
    date: '30/06/2026',
    changes: [
      {
        type: 'improvement',
        description: 'Ata de Banca: texto do preâmbulo simplificado, removida referência direta à Resolução GR-074/2020.',
        diff: {
          before: 'Procedimento de heteroidentificação complementar à autodeclaração dos candidatos(as) negros(as) (pretos e pardos), para fins de preenchimento das vagas reservadas no sistema de cotas étnico-raciais da Universidade Estadual de Campinas, conforme disposto na Resolução GR-074/2020.',
          after: 'Procedimento de heteroidentificação complementar à autodeclaração dos candidatos negros (pretos e pardos), para fins de preenchimento das vagas reservadas no sistema de cotas étnico-raciais da Universidade Estadual de Campinas.'
        }
      },
      {
        type: 'improvement',
        description: 'Ata de Banca: adicionado campo "Data" antes de "Unidade/Órgão". Texto de abertura da reunião unificado para todos os tipos de banca.',
        diff: {
          before: 'Unidade/Órgão: ...\nEdital: ...\n\nNo dia X do mês de Y de Z, reuniu-se na sala virtual da conta institucional DHAVES, a Banca de Heteroidentificação Virtual/Recursal, para, sob a presidência do primeiro, realizar o procedimento de heteroidentificação complementar à autodeclaração firmada pelos(as) candidatos(as) negros (pretos e pardos)...',
          after: 'Data: dia X do mês de Y de Z\nUnidade/Órgão: ...\nEdital: ...\n\nNa presente data, reuniu-se a Banca de Heteroidentificação [Tipo], para, sob a presidência do primeiro, realizar o procedimento de heteroidentificação, tendo sido convocados para essa finalidade.'
        }
      },
      {
        type: 'feature',
        description: 'Ata de Banca: novos textos descritivos do procedimento diferenciados por tipo — Facial (análise de fotos), Virtual (entrevista gravada) e Recursal (análise de vídeos/fotos anteriores).',
        diff: {
          before: 'Virtual: Os(as) candidatos(as), abaixo relacionados, compareceram na presente data e horário perante a Banca de Heteroidentificação Virtual, apresentaram a documentação solicitada na convocação e, mediante ato contínuo, foram entrevistados(as)...\n\nRecursal: Os vídeos dos candidatos(as) que protocolaram recurso... foram analisados, individualmente, em sessão gravada em áudio e vídeo...',
          after: 'Facial: As fotos dos candidatos foram apresentadas individualmente aos membros da banca para análise, e na sequência foi realizada a votação, pelo processo de heteroidentificação por critérios fenotípicos para aferir e validar a autodeclaração apresentada no ato da inscrição.\n\nVirtual: Os candidatos abaixo relacionados compareceram na presente data e horário, apresentaram documentação oficial com foto e, mediante ato contínuo, foram entrevistados individualmente em sessão gravada em áudio e vídeo. Na sequência foi realizada a votação...\n\nRecursal: Considerando as interposições de recursos, foram analisados individualmente os vídeos dos candidatos coletados durante a Banca de Heteroidentificação Virtual e/ou as fotos utilizadas na Banca de Heteroidentificação Facial. Na sequência foi realizada a votação...'
        }
      },
      {
        type: 'feature',
        description: 'Ata de Banca: adicionado resumo numérico de candidatos (Avaliados, Validados, Não Validados, Inconclusivos, Ausentes) antes da lista de nomes, variando conforme o tipo de banca.'
      },
      {
        type: 'improvement',
        description: 'Ata de Banca: seção de composição renomeada para "Membros" com indicação de "(Presidente)". Seção de equipe de apoio renomeada para "Apoio Técnico", com "Secretário" agora exibido como "Técnico da Banca".',
        diff: {
          before: 'Docente: Fulano (Presidente da Banca)\n...\nEquipe de apoio:\nSecretário da Banca: ...\nTécnico de Mídia I: ...\nTécnico de Mídia II: ...',
          after: 'Membros:\nDocente: Fulano (Presidente)\n...\nApoio Técnico:\nTécnico da Banca: ...\nTécnico: ...'
        }
      },
      {
        type: 'improvement',
        description: 'Ata de Banca: seção "Dados Técnicos" diferenciada por tipo de banca — Facial não exibe sala de espera, Recursal exibe apenas link da sala da banca.'
      },
      {
        type: 'improvement',
        description: 'Ata de Banca: texto final alterado.',
        diff: {
          before: 'Nada mais havendo a constar, foi lavrada a presente ata que lida e achada conforme segue assinada pelo(a) Presidente.',
          after: 'Sem mais nada a tratar, lavrou-se a presente ata que, após lida e aprovada, segue assinada pelo Presidente da Banca.'
        }
      },
      {
        type: 'feature',
        description: 'Ata Complementar (Validados Anteriormente): adicionado código de autenticação digital no rodapé do documento, substituindo a necessidade de assinatura física.'
      },
      {
        type: 'improvement',
        description: 'Cabeçalho de todos os PDFs atualizado: novo logotipo da Diretoria Executiva de Direitos Humanos (DEDH) e texto institucional com contato (cavu@unicamp.br | direitoshumanos.unicamp.br).'
      },
      {
        type: 'improvement',
        description: 'Termos de Heteroidentificação: o documento PDF deixa de ser emitido para candidatos com resultado "não validado" ou "inconclusivo". Esses candidatos continuam recebendo o resultado apenas no corpo do e-mail.'
      },
      {
        type: 'improvement',
        description: 'Termos de Heteroidentificação (Validados): novo texto do termo.',
        diff: {
          before: 'A Comissão de Heteroidentificação, responsável pelo procedimento de heteroidentificação complementar à autodeclaração dos candidatos negros (pretos e pardos) por aferição virtual, para fins de preenchimento das vagas reservadas no sistema de cotas étnico-raciais da UNICAMP, faz saber que sua autodeclaração foi considerada VALIDADA, em conformidade com a Resolução GR 074/2020, Artigo 1º, inciso I e inciso III.',
          after: 'A Banca de Heteroidentificação [Facial/Virtual/Recursal] convocada para realização do procedimento de heteroidentificação complementar à autodeclaração dos candidatos negros (pretos e pardos), utilizando exclusivamente o critério fenotípico para aferição da condição declarada pelo candidato, para fins de preenchimento das vagas reservadas no sistema de cotas étnico-raciais da UNICAMP, faz saber que sua autodeclaração foi considerada VALIDADA em conformidade com o edital e as legislações vigentes.'
        }
      }
    ]
  },
  {
    date: '09/03/2026',
    changes: [
      {
        type: 'feature',
        description: 'Validação técnica de fotos no upload via integração: tamanho mínimo (300 KB), tamanho máximo (10 MB) e formatos aceitos (JPEG, PNG) agora são verificados antes do envio.'
      },
      {
        type: 'feature',
        description: 'Os limites de foto passaram a ser configuráveis dinamicamente pela nova página "Config. Foto" na área de Administração, sem necessidade de deploy.'
      },
      {
        type: 'improvement',
        description: 'Na sidebar, o item "Configurações" (para administradores) foi separado em "Config. Candidato" e "Config. Foto" para refletir melhor os domínios distintos.'
      }
    ]
  },
  {
    date: '19/02/2026',
    changes: [
      {
        type: 'feature',
        description: 'Responsáveis por contas de serviço agora têm uma página própria ("Minhas Contas") para visualizar e gerenciar suas contas, incluindo a preferência de recebimento de e-mails de integração.'
      },
      {
        type: 'integration',
        description: 'Ao abrir a integração de candidatos de um processo, as contas de serviço vinculadas passam a receber uma notificação por e-mail, respeitando a preferência de cada conta.'
      },
      {
        type: 'improvement',
        description: 'A seleção de conta de serviço na criação de processo agora exibe um resumo com os detalhes da conta escolhida.'
      }
    ]
  },
  {
    date: '13/02/2026',
    changes: [
      {
        type: 'feature',
        description: 'Reimplementamos a Auditoria de Entidades (Admin) com nova tela dedicada, filtros por entidade/ator/operação/período, paginação e visualização completa dos dados auditados por revisão.'
      },
      {
        type: 'improvement',
        description: 'No backend, a consulta de auditoria administrativa foi refeita para usar endpoints novos e padronizados, com whitelist de entidades auditáveis e resposta paginada.'
      },
      {
        type: 'fix',
        description: 'Removemos o fluxo legado de auditoria por entidade (switch global, store e modal antigos), reduzindo acoplamentos e gambiarras.'
      },
      {
        type: 'improvement',
        description: 'Mantivemos a Auditoria de Heteroidentificações (DEDH) como fluxo separado, preservando sua página e endpoints específicos.'
      },
      {
        type: 'feature',
        description: 'Implementamos o fluxo de requisição e aprovação para alteração de dados sensíveis de candidatos (alteração de status e deleção do Candidato), separado do fluxo antigo de edição.'
      },
      {
        type: 'improvement',
        description: 'A solicitação de ação sensível passou a exigir chamado no Jira e ficou disponível em modal dedicado, com distinção clara entre alteração de status e deleção do Candidato.'
      },
      {
        type: 'feature',
        description: 'Criamos a página administrativa de avaliação das solicitações sensíveis, com ações de aprovar/rejeitar e visualização humanizada (processo, candidato, solicitante, inscrição e edital).'
      },
      {
        type: 'improvement',
        description: 'Adicionamos badge na sidebar para administradores com a quantidade de solicitações sensíveis pendentes.'
      },
      {
        type: 'integration',
        description: 'Agora administradores recebem notificação por e-mail quando uma nova solicitação sensível de candidato é criada.'
      }
    ]
  },
  {
    date: '10/02/2026',
    changes: [
      {
        type: 'feature',
        description: 'Criamos o acesso público do candidato em /candidato para consultar a sala da banca virtual e o fluxo de recurso.'
      },
      {
        type: 'improvement',
        description: 'A tela foi organizada por domínio (Banca Virtual e Banca Recursal) com a Banca Recursal focada apenas no recurso e indicação de preenchimento.'
      },
      {
        type: 'fix',
        description: 'Limpamos o contrato de resposta dessa consulta pública, removendo campos legados e deixando o DTO mais claro para evolução.'
      },
      {
        type: 'improvement',
        description: 'Adicionamos proteção anti-bot sem dependência externa (desafio próprio + limite de tentativas) e correção de auditoria para configuração de acesso do candidato.'
      }
    ]
  },
  {
    date: '09/02/2026',
    changes: [
      {
        type: 'feature',
        description: 'Agora a integração de candidatos pode ser aberta e finalizada no nível de processo, com fluxo separado da integração de bancas.'
      },
      {
        type: 'integration',
        description: 'Upload e atualização de foto na integração passaram a respeitar a integração aberta do processo, sem depender de banca em integração. (Fluxo específico independente de Banca)'
      },
      {
        type: 'improvement',
        description: 'Atualizamos o status de candidato de INDEFINIDO para NAO_AVALIADO em todo o sistema, com migração de banco e ajustes na API, scripts e telas.'
      }
    ]
  },
  {
    date: '09/02/2026',
    changes: [
      {
        type: 'improvement',
        description: 'Separamos os perfis de usuário e os perfis de conta de serviço, deixando cada domínio com sua responsabilidade.'
      },
      {
        type: 'fix',
        description: 'Aprovação de conta de serviço ficou mais estável: corrigimos a integração com a AC/Keycloak e mensagens de erro.'
      },
      {
        type: 'integration',
        description: 'No ambiente local, as contas de serviço criadas para teste agora também são criadas no Keycloak com o mesmo client_id do banco.'
      }
    ]
  },
  {
    date: '06/02/2026',
    changes: [
      {
        type: 'integration',
        description: 'Novo endpoint de integração para listar identificadores de processos ativos com seus editais. Facilita a descoberta de processos e editais para sistemas externos que precisam integrar com o Identifica.'
      }
    ]
  }
];

const Changelog: React.FC = () => {
  const getTypeLabel = (type: string) => {
    const labels = {
      feature: 'Nova Funcionalidade',
      improvement: 'Melhoria',
      fix: 'Correção',
      integration: 'Integração'
    };
    return labels[type as keyof typeof labels] || type;
  };

  const getTypeColor = (type: string) => {
    const colors = {
      feature: '#22c55e',
      improvement: '#3b82f6',
      fix: '#ef4444',
      integration: '#8b5cf6'
    };
    return colors[type as keyof typeof colors] || '#64748b';
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <BsClockHistory className={styles.icon} />
        <h1>Histórico de Atualizações</h1>
        <p>Acompanhe as novidades e melhorias do sistema</p>
      </div>

      <div className={styles.timeline}>
        {changelogData.map((entry, index) => (
          <div key={index} className={styles.entry}>
            <div className={styles.date}>
              <span>{entry.date}</span>
              {entry.version && <span className={styles.version}>{entry.version}</span>}
            </div>
            <div className={styles.changes}>
              {entry.changes.map((change, changeIndex) => (
                <div key={changeIndex} className={styles.change}>
                  <span 
                    className={styles.badge}
                    style={{ backgroundColor: getTypeColor(change.type) }}
                  >
                    {getTypeLabel(change.type)}
                  </span>
                  <p>{change.description}</p>
                  {change.diff && (
                    <div className={styles.diffContainer}>
                      <div className={styles.diffBefore}>
                        <span className={styles.diffLabel}>Antes:</span>
                        <span className={styles.diffText}>{change.diff.before}</span>
                      </div>
                      <div className={styles.diffAfter}>
                        <span className={styles.diffLabel}>Agora:</span>
                        <span className={styles.diffText}>{change.diff.after}</span>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Changelog;
